import './App.css';
import { useState, useEffect } from 'react';
import { useElevenLabsConversation } from './ConversationService.js';

function App() {
  const [priorCustomerContext, setPriorCustomerContext] = useState('');
  const [personId, setPersonId] = useState('');
  const [latestMemory, setLatestMemory] = useState('');
  const [isFetchingContext, setIsFetchingContext] = useState(false);
  const [fetchError, setFetchError] = useState(null);
  const {
    startConversation,
    endConversation,
    sendUserMessage,
    status,
    isSpeaking,
    messages,
    error,
  } = useElevenLabsConversation();

  // Read person ID from URL query parameters on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlPersonId = params.get('personId');
    if (urlPersonId) {
      setPersonId(urlPersonId);
      // Automatically fetch context if person ID is provided in URL
      handleFetchContext(urlPersonId);
    }
  }, []);

  useEffect(() => {
    const messageContainer = document.getElementById('conversationMessagesContainer');
    if (messageContainer) {
      messageContainer.scrollTop = messageContainer.scrollHeight;
    }
  }, [messages]);

  const handleToggleConversation = () => {
    if (status === 'connected' || status === 'connecting') {
      endConversation();
    } else {
      startConversation(priorCustomerContext, personId, latestMemory);
    }
  };

  const handleFetchContext = async (id = personId) => {
    if (!id.trim()) {
      setFetchError('Please enter a Person ID.');
      alert('Please enter a Person ID.');
      return;
    }
    setIsFetchingContext(true);
    setFetchError(null);
    try {
      const response = await fetch(`https://rise-ai-backend.onrender.com/persons/${id}/context`);
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: "Failed to fetch context, server returned an error." }));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.user_context) {
        setPriorCustomerContext(data.user_context);
      } else {
        console.warn("User context not found in API response, but proceeding if other fields exist.");
      }
      if (data && data.latest_memory) {
        setLatestMemory(data.latest_memory);
      } else {
        console.warn("Latest memory not found in API response.");
      }
      if (!(data && (data.user_context || data.latest_memory))) {
        throw new Error("Neither user context nor latest memory found in API response.");
      }
    } catch (error) {
      console.error("Failed to fetch context:", error);
      setFetchError(error.message);
    } finally {
      setIsFetchingContext(false);
    }
  };

  let conversationButtonText = 'Start Voice Chat';
  if (status === 'connecting') {
    conversationButtonText = 'Connecting...';
  } else if (status === 'connected') {
    conversationButtonText = 'End Voice Chat';
  }

  return (
    <div className="flex flex-col h-screen bg-[#16161A]">
      <main className="flex flex-1 p-4 space-x-4 overflow-hidden">
        {/* Left Pane: Input and Customization */}
        {/* <div className="flex flex-col w-1/4 p-6 space-y-4 bg-white rounded-lg shadow-md overflow-y-auto">
          <h2 className="text-xl font-semibold text-gray-700 border-b pb-2">Input & Settings</h2>
          <div>
            <label htmlFor="personIdInput" className="block text-sm font-medium text-gray-700">
              Person ID:
            </label>
            <div className="mt-1 flex space-x-2">
              <input
                type="text"
                id="personIdInput"
                name="personIdInput"
                className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Enter Person ID..."
                value={personId}
                onChange={(e) => setPersonId(e.target.value)}
                disabled={isFetchingContext}
              />
              <button
                type="button"
                onClick={() => handleFetchContext(personId)}
                disabled={!personId.trim() || isFetchingContext}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
              >
                {isFetchingContext ? 'Fetching...' : 'Fetch Context'}
              </button>
            </div>
            {fetchError && <p className="mt-1 text-xs text-red-600">{fetchError}</p>}
          </div>
          <div>
            <label htmlFor="priorContextTextArea" className="block text-sm font-medium text-gray-700">
              Prior Customer Context:
            </label>
            <div className="mt-1">
              <textarea
                id="priorContextTextArea"
                name="priorContextTextArea"
                rows={5}
                className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Paste any prior customer context here or fetch from Person ID..."
                value={priorCustomerContext}
                onChange={(e) => setPriorCustomerContext(e.target.value)}
              />
            </div>
          </div>
          <div>
            <label htmlFor="latestMemoryTextArea" className="block text-sm font-medium text-gray-700">
              Latest Memory:
            </label>
            <div className="mt-1">
              <textarea
                id="latestMemoryTextArea"
                name="latestMemoryTextArea"
                rows={5}
                className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Latest memory will be populated by fetching context..."
                value={latestMemory}
                onChange={(e) => setLatestMemory(e.target.value)}
              />
            </div>
          </div>
          <div className="pt-4 border-t mt-auto">
            <p className="text-sm text-gray-500">Customization options will go here.</p>
          </div>
        </div> */}

        {/* Center Pane: Controls and Status */}
        <div className="flex flex-col w-full p-6 space-y-6 overflow-y-auto">
          <div className="space-y-2">
            <button
              type="button"
              onClick={handleToggleConversation}
              disabled={status === 'connecting'}
              className="w-full px-4 py-3 text-base font-medium text-white bg-green-600 border border-transparent rounded-md shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50"
            >
              {conversationButtonText}
            </button>
          </div>

          <div className="">
            <h3 className="text-lg font-semibold text-gray-100 mb-2">Person Context:</h3>
            <div className="text-sm text-gray-200 space-y-1" id="agentStatusDisplay">
              <p>Person Id: <span className="font-medium text-gray-400">{personId}</span></p>
            </div>
            
          </div>
          
          <div className="">
            <h3 className="text-lg font-semibold text-gray-100 mb-2">Agent Status:</h3>
            <div className="text-sm text-gray-200 space-y-1" id="agentStatusDisplay">
              <p>Status: <span className="font-medium text-gray-400">{status || 'idle'}</span></p>
              <p>Agent Speaking: <span className="font-medium text-gray-400">{isSpeaking ? 'Yes' : 'No'}</span></p>
              {error && (
                <p className="text-red-600">Error: <span className="font-medium">{error}</span></p>
              )}
            </div>
            
          </div>

          <div id="conversationMessagesContainer" className="">
            {messages.length === 0 && <p className="text-sm text-gray-500 italic">No messages yet. Start the voice chat to begin.</p>}
            {messages.map((msg, index) => {
              let sender = 'Unknown';
              let textContent = '';
              // Basic message parsing, can be expanded
              if (msg && msg.type === 'user_input_transcription' && msg.text) {
                sender = 'You';
                textContent = msg.text;
              } else if (msg && msg.type === 'agent_response_text' && msg.text) {
                sender = 'AI Coach';
                textContent = msg.text;
              } else if (msg && msg.payload && typeof msg.payload.text === 'string') { // General payload text
                 sender = msg.source === 'user' ? 'You' : 'AI Coach';
                 textContent = msg.payload.text;
              } else if (typeof msg === 'string') { // Plain string message
                textContent = msg;
                sender = 'System'; // Or assume sender based on context if needed
              } else { // Fallback for unknown message structures
                sender = msg.source || (msg.type ? msg.type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : 'System');
                textContent = JSON.stringify(msg);
              }

              return (
                <div key={index} 
                     className={`p-3 rounded-lg m-2 break-words ${sender === 'You' ? 'bg-blue-100 text-blue-800 ml-auto' : 'bg-green-100 text-green-800 mr-auto'}`}>
                  <strong className="block text-xs font-semibold mb-1">{sender}:</strong>
                  <p className="text-sm whitespace-pre-wrap">{textContent}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Right Pane: Conversation Transcript */}
        {/* <div className="flex flex-col w-1/4 p-6 bg-white rounded-lg shadow-md overflow-hidden">
          <h2 className="text-xl font-semibold text-gray-700 border-b pb-2 mb-3">Conversation</h2>
          
        </div> */}
      </main>
    </div>
  );
}

export default App;
